import React, { useRef, useEffect, useState } from 'react'


import roomTiltLogic from '../utils/roomTiltLogic'

import { createRoomMovement } from '../utils/roomHelpers'
import { TransitionStatus } from 'react-transition-group/Transition'

// rxjs is a library capable of great things.
// Learning it is hard and i am sorry but i see no other perfect way but to use it here.
// https://css-tricks.com/animated-intro-rxjs/


interface UseRoomMovementProps {
	enableTilt: boolean,
	enableTopView: boolean,

	transitionStatus: TransitionStatus
	// transitionStatus: TransitionStatus
}

export const useRoomMovement = (({
	enableTilt,
	enableTopView,
	transitionStatus
}) => {
	const scrollerRef = useRef<HTMLDivElement>(null)
	const [activeInit, setActiveInit] = useState(true)
	const [activeTilt, setActiveTilt] = useState(false)
	const [activeTopView, setActiveTopView] = useState(false)
	const [isInTopView, setIsInTopView] = useState(false)

	// transitionStatus
	// "entering" | "entered" | "exiting" | "exited" | "unmounted"


	useEffect(() => {
		const transitionend = (event: TransitionEvent) => {
			if (event.target === scrollerRef.current) {
				scrollerRef.current.removeEventListener("transitionend", transitionend)
				setActiveInit && setActiveInit(false)
			}
		}

		if (transitionStatus === "entered") {
			scrollerRef.current.style.transition = "transform 0.6s ease"
			scrollerRef.current.getBoundingClientRect()

			scrollerRef.current.addEventListener("transitionend", transitionend)
			requestAnimationFrame(() => {
				if (scrollerRef.current) {
					scrollerRef.current.style.transform = createRoomMovement({ translateZ: "500px" })
				}
			})
		}

		return () => {
			scrollerRef.current.removeEventListener("transitionend", transitionend)
		}
	}, [transitionStatus])


	// Tilt when the mouse moves.
	useEffect(() => {
		// Cleanup variables.
		let mouseMove

		// io variables
		const { smoothMove$ } = roomTiltLogic()

		const canStart = (
			enableTilt
			&& transitionStatus === "entered"
			&& !activeInit
			&& !activeTopView
			&& !enableTopView
			&& !isInTopView
		)

		const canSetUpTilt = canStart && !activeTilt
		if (canSetUpTilt) {
			setActiveTilt(true)
			scrollerRef.current.style.transition = "none"
			scrollerRef.current.getBoundingClientRect()

			mouseMove = smoothMove$.subscribe(transform => {
				scrollerRef.current.style.transform = transform
			})
		}

		return () => {
			mouseMove && mouseMove.unsubscribe()
			!canStart && requestAnimationFrame(() => { setActiveTilt && setActiveTilt(false) })
		}
	}, [transitionStatus, enableTopView, enableTilt, activeTopView, activeInit, isInTopView])

	
	useEffect(() => {
		const canStart = (
			transitionStatus === "entered"
			&& !activeTilt
			&& !activeInit
			&& (enableTopView || isInTopView)
		)

		const moveUpTransform = createRoomMovement({
			translateY: "50%",
			translateZ: "0px",
			rotateX: -10,
			rotateY: 0,
			rotateZ: 0
		})
		const moveDownTransform = createRoomMovement({ translateZ: "500px" })

		const transitionend = (event: TransitionEvent) => {
			if (event.target === scrollerRef.current) {
				setActiveTopView(false)
				scrollerRef.current.removeEventListener("transitionend", transitionend)
			}
		}

		const shouldGoUp = !isInTopView		
		if(canStart && shouldGoUp) {
			setActiveTopView(true)
			setIsInTopView(true)

			scrollerRef.current.style.transition = "transform 1s cubic-bezier(0.2, 1, 0.3, 1)"
			scrollerRef.current.getBoundingClientRect()

			scrollerRef.current.addEventListener("transitionend", transitionend)
			requestAnimationFrame(() => {
				if (scrollerRef.current) {
					scrollerRef.current.style.transform = moveUpTransform
				}
			})
		}
		if(canStart && !shouldGoUp) {
			setActiveTopView(true)
			setIsInTopView(false)

			scrollerRef.current.style.transition = "transform 1s cubic-bezier(0.2, 1, 0.3, 1)"
			scrollerRef.current.getBoundingClientRect()

			scrollerRef.current.addEventListener("transitionend", transitionend)
			requestAnimationFrame(() => {
				if (scrollerRef.current) {
					scrollerRef.current.style.transform = moveDownTransform
				}
			})
		}

		return () => {
			scrollerRef.current.removeEventListener("transitionend", transitionend)
		}

	}, [enableTopView, transitionStatus, activeTilt, activeInit])

	return {
		scrollerRef,
	}
})
